import React, { FC } from "react";
// import imagePng2 from "images/hero-right-3.png";
import imagePng from "images/hero-right-1.jpg";
// import imagePng3 from "images/hero-right-5.jpg";
import imagePng4 from "images/hero-right-2.jpg";
import imagePng5 from "images/hero-right-3.jpg";
import imagePng6 from "images/hero-right-4.jpg";
// import imagePng from "images/travelhero2.png";

import GallerySlider from "components/GallerySlider/GallerySliderHero";

import HeroRealEstateSearchForm from "components/HeroSearchForm/(real-estate-search-form)/HeroRealEstateSearchForm2";

export interface SectionHero2Props {
  className?: string;
  children?: React.ReactNode;
}

const galleryImgs = [imagePng,imagePng4,imagePng5,imagePng6];




const renderSliderGallery = () => {
  return (
    // <div className="absolute inset-0 object-cover w-full h-full">
    // <div >
<div className="absolute inset-0 object-cover w-full h-full">
      <GallerySlider
        ratioClass=""
        galleryImgs={galleryImgs}
        uniqueID={`StayCardH_id1`}
        href={"/"}
      />
     
    </div>
  );
};

const SectionHero2: FC<SectionHero2Props> = ({ className = "", children }) => {
  return (
    <div
      className={`nc-SectionHero2 relative ${className} h-[450px] sm:h-[750px] md:h-[800px] lg:h-[800px]`}
      data-nc-id="SectionHero2"
    >
      {/* <div className="absolute inset-y-0 w-full  right-0 flex-grow"> */}
      <div className="absolute inset-0 w-full   ">
        {renderSliderGallery()}
        {/* <img
          className="absolute inset-0 object-cover w-full h-full"
          src={imagePng}
          alt="hero"
        /> */}
      </div>
      {/* <div className="relative py-14 lg:py-[250px]">
        <div className="relative inline-flex">
          <div className="w-screen right-20 md:right-52 inset-y-0 absolute bg-primary-500"></div>
          <div className="relative max-w-3xl inline-flex flex-shrink-0 flex-col items-start py-16 sm:py-20 lg:py-24 space-y-8 sm:space-y-10 text-white">
            {children ? (
              children
            ) : (
              <h2 className="font-semibold text-4xl md:text-5xl xl:text-7xl !leading-[110%]">
                Find Your Best <br /> Smart Real Estate
              </h2>
            )}
          </div>
        </div>
        <div className="hidden lg:block ">
          <HeroRealEstateSearchForm />
        </div>
      </div> */}
          <div className="relative pt-[110px] ">
        <div className="hidden lg:block ">
          <HeroRealEstateSearchForm />
        </div>
      </div>
    </div>
  );
};

export default SectionHero2;
